import { createRouter, createWebHistory  } from 'vue-router'
import headView from '../views/HeadView.vue'
import aboutView from '../views/AboutView.vue'
import Loginview from '../views/Login.vue'

const routes = [
  {
    path: '/',
    name: 'head',
    component: headView,
    children: [
      {
        path: '/',
        name: 'HomeView',
        component: () => import('../views/page/HomeView.vue'),
      },
      {
        path: '/EducationalView',
        name: 'EducationalView',
        component: () => import('../views/page/EducationalView.vue'),
      },
      {
        path: '/SkillsCompetition/:id',
        name: 'SkillsCompetition',
        component: () => import('../views/page/SkillsCompetition.vue'),
      },
      {
        path: '/SkillsCompetitionDetail/:id',
        name: 'SkillsCompetitionDetail',
        component: () => import('../views/page/SkillsCompetitionDetail.vue'),
      },
      {
        path: '/CollaborativeEducationDetail/:id',
        name: 'CollaborativeEducationDetail',
        component: () => import('../views/CollaborativeEducation/CollaborativeEducationDetail.vue'),
      },
      {
        path: '/CollaborativeEducationList',
        name: 'CollaborativeEducationList',
        component: () => import('../views/CollaborativeEducation/CollaborativeEducationList.vue'),
      },
      {
        path: '/CollaborativeEducation',
        name: 'CollaborativeEducation',
        component: () => import('../views/page/CollaborativeEducation.vue'),
      },
      {
        path: '/Meeting',
        name: 'Meeting',
        component: () => import('../views/Meeting/Meeting.vue'),
      },
      {
        path: '/InvitationLetter/:id',
        name: 'InvitationLetter',
        component: () => import('../views/Meeting/InvitationLetter.vue'),

      },
      {
        path: '/SkillsCompetitionList',
        name: 'SkillsCompetitionList',
        component: () => import('../views/page/SkillsCompetitionList.vue'),

      },
      {
        path: '/News',
        name: 'News',
        component: () => import('../views/News/News.vue'),
      },
      {
        path: '/NewsDetail/:id',
        name: 'NewsDetail',
        component: () => import('../views/News/NewsDetail.vue'),
      },
      {
        path: '/ChannelCooperation',
        name: 'ChannelCooperation',
        component: () => import('../views/page/ChannelCooperation.vue'),
      },
      {
        path: '/AboutUs',
        name: 'AboutUs',
        component: () => import('../views/page/AboutUs.vue'),
      },
      {
        path: '/EducationalProducts',
        name: 'EducationalProducts',
        component: () => import('../views/EducationalProducts/EducationalProducts.vue'),
      },
      {
        path: '/ModelCase',
        name: 'ModelCase',
        component: () => import('../views/ModelCase/ModelCase.vue'),
      },
      {
        path: '/fudan',
        name: 'fudan',
        component: () => import('../views/ModelCase/fudan.vue'),
        meta: { title: '复旦大学-支持实验实训教学-晨鸟科技' }
      },
      {
        path: '/lijiang',
        name: 'lijiang',
        component: () => import('../views/ModelCase/lijiang.vue'),
        meta: { title: '丽江文化旅游学院-支持实验实训教学-晨鸟科技' }
      },
      {
        path: '/Baise',
        name: 'Baise',
        component: () => import('../views/ModelCase/Baise.vue'),
        meta: { title: '百色学院-支持实验实训教学-晨鸟科技' }
      },
      {
        path: '/huaqiao',
        name: 'huaqiao',
        component: () => import('../views/ModelCase/huaqiao.vue'),
        meta: { title: '华侨大学-支持实验实训教学-晨鸟科技' }
      },
      {
        path: '/zhanjiang',
        name: 'zhanjiang',
        component: () => import('../views/ModelCase/zhanjiang.vue'),
        meta: { title: '湛江科技学院-支持实验实训教学-晨鸟科技' }
      },
      {
        path: '/luoyang',
        name: 'luoyang',
        component: () => import('../views/ModelCase/luoyang.vue'),
        meta: { title: '洛阳师范大学-支持实验实训教学-晨鸟科技' }
      },
      {
        path: '/shanghaishifan',
        name: 'shanghaishifan',
        component: () => import('../views/ModelCase/shanghaishifan.vue'),
        meta: { title: '上海师范大学-支持实验实训教学-晨鸟科技' }
      },
      {
        path: '/shanghaishanda',
        name: 'shanghaishanda',
        component: () => import('../views/ModelCase/shanghaishanda.vue'),
        meta: { title: '上海杉达学院-支持实验实训教学-晨鸟科技' }
      },
      {
        path: '/shanghailida',
        name: 'shanghailida',
        component: () => import('../views/ModelCase/shanghailida.vue'),
        meta: { title: '上海立达学院-支持实验实训教学-晨鸟科技' }
      },
      {
        path: '/shandonglvyou',
        name: 'shandonglvyou',
        component: () => import('../views/ModelCase/shandonglvyou.vue'),
        meta: { title: '山东旅游职业学院-支持实验实训教学-晨鸟科技' }
        
      },
      {
        path: '/hebeilvyou',
        name: 'hebeilvyou',
        component: () => import('../views/ModelCase/hebeilvyou.vue'),
        meta: { title: '河北旅游职业学院-支持实验实训教学-晨鸟科技' }
      },
      {
        path: '/chongqinggongshang',
        name: 'chongqinggongshang',
        component: () => import('../views/ModelCase/chongqinggongshang.vue'),
        meta: { title: '重庆工商职业学院-支持实验实训教学-晨鸟科技' }
      },
      {
        path: '/shanxilvyou',
        name: 'shanxilvyou',
        component: () => import('../views/ModelCase/shanxilvyou.vue'),
        meta: { title: '山西艺术职业学院-支持实验实训教学-晨鸟科技' }
      },
      {
        path: '/ningbo',
        name: 'ningbo',
        component: () => import('../views/ModelCase/ningbo.vue'),
        meta: { title: '宁波东钱湖旅游学院-支持实验实训教学-晨鸟科技' }
      },
      {
        path: '/beijing',
        name: 'beijing',
        component: () => import('../views/ModelCase/beijing.vue'),
        meta: { title: '北京工业职业技术学院-支持实验实训教学-晨鸟科技' }
      },
      {
        path: '/hainan',
        name: 'hainan',
        component: () => import('../views/ModelCase/hainan.vue'),
        meta: { title: '海南贸易职业技术学院-支持实验实训教学-晨鸟科技' }
      },
      {
        path: '/huangshan',
        name: 'huangshan',
        component: () => import('../views/ModelCase/huangshan.vue'),
        meta: { title: '黄山学院-支持实验实训教学-晨鸟科技' }
      },
      {
        path: '/BlockchainHotel',
        name: 'BlockchainHotel',
        component: () => import('../views/EducationalProducts/BlockchainHotel.vue'),
        meta: { title: '区块链酒店数字化接待系统-晨鸟出品、必属精品-精益求精的数字教育产品' }
      },
      {
        path: '/Blockchain',
        name: 'Blockchain',
        component: () => import('../views/EducationalProducts/Blockchain.vue'),
        meta: { title: '基于大模型的区块链供应链金融营运仿真博弈平台(沙盘版/PC 版)-晨鸟出品、必属精品-精益求精的数字教育产品' }
      },
      {
        path: '/CrossBorder',
        name: 'CrossBorder',
        component: () => import('../views/EducationalProducts/CrossBorder.vue'),
        meta: { title: '基于大模型的跨境电子商务营运仿真博弈平台(沙盘版/PC 版)-晨鸟出品、必属精品-精益求精的数字教育产品' }
      },
      {
        path: '/Catering',
        name: 'Catering',
        component: () => import('../views/EducationalProducts/Catering.vue'),
        meta: { title: '基于大模型的餐饮数字化运营管理仿真博弈平台(沙盘版/PC 版)-晨鸟出品、必属精品-精益求精的数字教育产品' }
      },
      {
        path: '/DigitalCompetition',
        name: 'DigitalCompetition',
        component: () => import('../views/EducationalProducts/DigitalCompetition.vue'),
        meta: { title: '数字化竞赛区块链及可视化系统-晨鸟出品、必属精品-精益求精的数字教育产品' }
      },
      {
        path: '/DigitalTeaching',
        name: 'DigitalTeaching',
        component: () => import('../views/EducationalProducts/DigitalTeaching.vue'),
        meta: { title: '数字助教情感识别系统-晨鸟出品、必属精品-精益求精的数字教育产品' }
      },{
        path: '/AI',
        name: 'AI',
        component: () => import('../views/EducationalProducts/AI.vue'),
        meta: { title: '智能答题助手-晨鸟出品、必属精品-精益求精的数字教育产品' }
      },
      {
        path: '/DigitalTtourism',
        name: 'DigitalTtourism',
        component: () => import('../views/EducationalProducts/DigitalTtourism.vue'),
        meta: { title: '数字旅游创业实践平台-晨鸟出品、必属精品-精益求精的数字教育产品' }
      },
      {
        path: '/Ecommerce',
        name: 'Ecommerce',
        component: () => import('../views/EducationalProducts/Ecommerce.vue'),
        meta: { title: '基于大模型的电子商务营运仿真博弈平台(沙盘版/PC 版)-晨鸟出品、必属精品-精益求精的数字教育产品' }
      },
      {
        path: '/entrepreneurship',
        name: 'entrepreneurship',
        component: () => import('../views/EducationalProducts/entrepreneurship.vue'),
        meta: { title: '大学生创新创业实践平台-晨鸟出品、必属精品-精益求精的数字教育产品' }
      },
      {
        path: '/Health',
        name: 'Health',
        component: () => import('../views/EducationalProducts/Health.vue'),
        meta: { title: '基于大模型的康养营运管理仿真博弈平台(沙盘版/PC 版)-晨鸟出品、必属精品-精益求精的数字教育产品' }
      },
      {
        path: '/Hotel',
        name: 'Hotel',
        component: () => import('../views/EducationalProducts/Hotel.vue'),
        meta: { title: '基于大模型的酒店数智化营运管理仿真博弈平台(沙盘版/PC 版)-晨鸟出品、必属精品-精益求精的数字教育产品' }
      },
      {
        path: '/Logistics',
        name: 'Logistics',
        component: () => import('../views/EducationalProducts/Logistics.vue'),
        meta: { title: '基于大模型的物流管理营运仿真博弈平台(沙盘版/PC 版)-晨鸟出品、必属精品-精益求精的数字教育产品' }
      },
      {
        path: '/MobileApplication',
        name: 'MobileApplication',
        component: () => import('../views/EducationalProducts/MobileApplication.vue'),
        meta: { title: '移动应用创新实践平台-晨鸟出品、必属精品-精益求精的数字教育产品' }
      },
      {
        path: '/Homestay',
        name: 'Homestay',
        component: () => import('../views/EducationalProducts/Homestay.vue'),
        meta: { title: '基于大模型的民宿运营管理仿真博弈平台(沙盘版/PC 版)-晨鸟出品、必属精品-精益求精的数字教育产品' }
      },
      {
        path: '/StudyTravel',
        name: 'StudyTravel',
        component: () => import('../views/EducationalProducts/StudyTravel.vue'),
        meta: { title: '基于大模型的研学旅行运营管理仿真博弈平台(沙盘版/PC 版)-晨鸟出品、必属精品-精益求精的数字教育产品' }
      },
      {
        path: '/Tourism',
        name: 'Tourism',
        component: () => import('../views/EducationalProducts/Tourism.vue'),
        meta: { title: '基于大模型的数字旅游营运管理仿真博弈平台(沙盘版/PC 版)-晨鸟出品、必属精品-精益求精的数字教育产品' }
      },
      {
        path: '/Exhibition',
        name: 'Exhibition',
        component: () => import('../views/EducationalProducts/Exhibition.vue'),
        meta: { title: '基于大模型的会展数字化运营管理仿真博弈平台(沙盘版/PC 版)-晨鸟出品、必属精品-精益求精的数字教育产品' }
      },
      {
        path: '/zhengzhoulvyou',
        name: 'zhengzhoulvyou',
        component: () => import('../views/ModelCase/zhengzhoulvyou.vue'),
        meta: { title: '郑州旅游职业学院-支持实验实训教学-晨鸟科技' }
      },
    ]
  },
  
  {
    path: '/login',
    name: 'login',
    component: Loginview
  },
  {
    path: '/:catchAll(.*)', 
    name: 'NotFound',
    pathMatch: 'full',
    meta: {
      requireAuth: true,
      title: '404',
    },
    component: () =>
      import(
        '../components/NotFound.vue'
      ),
  },
  {
    path: '/about',
    name: 'about',
    component: aboutView,
    children: [
      {
        path: '/TeacherInfoUpdate',
        name: 'TeacherInfoUpdate',
        meta: {
          requireAuth: true,
          title: '个人信息',
        },
        component: () =>
          import(
            '../views/manage/TeacherInfoUpdate.vue'
          ),
      },
      {
        path: '/EditPassword',
        name: 'EditPassword',
        meta: {
          requireAuth: true,
          title: '修改密码',
        },
        component: () =>
          import(
            '../views/manage/EditPassword.vue'
          ),
      },
      {
        path: '/NewsInformation',
        name: 'NewsInformation',
        meta: {
          requireAuth: true,
          title: '新闻动态',
        },
        component: () =>
          import(
            '../views/manage/NewsInformation.vue'
          ),
      },
      {
        path: '/CarouselImage',
        name: 'CarouselImage',
        meta: {
          requireAuth: true,
          title: '轮播图',
        },
        component: () =>
          import(
            '../views/manage/CarouselImage.vue'
          ),
      },
    ]
    
  },
]

const router = createRouter({
  history: createWebHistory('/cn/'),
  routes
  
})
router.beforeEach((to, from, next) => {
  
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
  next();

});

router.afterEach((to, from) => {
  // 跳转到特定路由时滚动到顶部
  if 
  (
    to.path === '/AI' || 
    to.path === '/fudan' || 
    to.path === '/huaqiao' ||
    to.path === '/zhanjiang' ||
    to.path === '/luoyang' || 
    to.path === '/shanghaishifan' ||
    to.path === '/shanghaishanda' ||
    to.path === '/shanghailida' ||
    to.path === '/huangshan' ||
    to.path === '/shandonglvyou' || 
    to.path === '/hebeilvyou' ||
    to.path === '/chongqinggongshang' ||
    to.path === '/shanxilvyou' || 
    to.path === '/ningbo' ||
    to.path === '/beijing' ||
    to.path === '/hainan' || 
    to.path === '/zhengzhoulvyou' ||

    to.path === '/News' || 
    to.path === '/EducationalProducts' || 
    to.path === '/ModelCase' || 
    to.path === '/SkillsCompetitionList' || 
    to.path === '/Meeting' || 
    to.path === '/ChannelCooperation' || 
    to.path === '/Hotel' ||
    to.path === '/Tourism' ||
    to.path === '/Exhibition' || 
    to.path === '/Catering' ||
    to.path === '/Health' ||
    to.path === '/Homestay' ||
    to.path === '/StudyTravel' ||
    to.path === '/Ecommerce' || 
    to.path === '/CrossBorder' ||
    to.path === '/Blockchain' ||
    to.path === '/Logistics' || 
    to.path === '/DigitalTtourism' ||
    to.path === '/MobileApplication' ||
    to.path === '/entrepreneurship' || 
    to.path === '/BlockchainHotel' ||
    to.path === '/DigitalTeaching' ||
    to.path === '/DigitalCompetition'
  ) {
    window.scrollTo(0, 0);
  }
  if (to.path.startsWith('/NewsDetail/')) {
    window.scrollTo(0, 0);
  }
  if (to.path.startsWith('/SkillsCompetitionDetail/')) {
    window.scrollTo(0, 0);
  }
  if (to.path.startsWith('/InvitationLetter/')) {
    window.scrollTo(0, 0);
  }
  if (to.path.startsWith('/CollaborativeEducationDetail/')) {
    window.scrollTo(0, 0);
  }
  
  if (to.hash) {
    let element = document.getElementById(to.hash.slice(1));
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
});

export default router
